import { Box, Typography, Paper } from '@mui/material';
import { ReactComponent as InfoIcon } from '../../assets/img/info-icon.svg';
import WindSpeedGraph from '../../components/Graphs/WindSpeedGraph';
import { LoadingSpinner } from '../common/LoadingSpinner';
import { ErrorState } from '../common/ErrorState';
import { NoDataState } from '../common/NoDataState';

export const WindSpeedWrapper = (props: any) => {
  const { isLoading, isError, error, hasData, categories, values } = props;

  // Show loading state
  if (isLoading) {
    return (
      <Paper 
        className="custom-chart"
        sx={{ 
          minWidth: '1000px', 
          maxWidth: '100%', 
          minHeight: '800px', 
          marginBottom: '7px', 
          padding: '20px',
          borderRadius: '16px',
          boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.08)',
          border: '1px solid rgba(229, 231, 235, 0.8)',
          background: 'linear-gradient(145deg, #ffffff 0%, #fafafa 100%)',
          overflow: 'hidden',
        }}>
        <LoadingSpinner 
          message="Loading wind speed data..." 
          height="800px"
          showBackground={false}
        />
      </Paper>
    );
  }

  // Show error state
  if (isError) {
    return (
      <Paper 
        className="custom-chart"
        sx={{ 
          minWidth: '1000px', 
          maxWidth: '100%', 
          minHeight: '800px', 
          marginBottom: '7px', 
          padding: '20px',
          borderRadius: '16px',
          boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.08)',
          border: '1px solid rgba(229, 231, 235, 0.8)',
          background: 'linear-gradient(145deg, #ffffff 0%, #fafafa 100%)',
          overflow: 'hidden',
        }}>
        <ErrorState 
          title="Failed to load wind speed data"
          error={error}
          height="800px"
          showBackground={false}
          onRetry={props.onRetry}
        />
      </Paper>
    );
  }

  // Show no data state
  if (!hasData) {
    return (
      <Paper 
        className="custom-chart"
        sx={{ 
          minWidth: '1000px', 
          maxWidth: '100%', 
          minHeight: '800px', 
          marginBottom: '7px', 
          padding: '20px',
          borderRadius: '16px',
          boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.08)',
          border: '1px solid rgba(229, 231, 235, 0.8)',
          background: 'linear-gradient(145deg, #ffffff 0%, #fafafa 100%)',
          overflow: 'hidden',
        }}>
        <NoDataState 
          title="No wind speed data available"
          message="No wind speed data found for the selected date range and filters. Try adjusting your selection criteria."
          height="800px"
          showBackground={false}
        />
      </Paper>
    );
  }

  return (
    <Paper 
      className="custom-chart"
      sx={{ 
        minWidth: '1000px', 
        maxWidth: '100%', 
        minHeight: '800px', 
        marginBottom: '7px', 
        padding: '20px',
        borderRadius: '16px',
        boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.08)',
        border: '1px solid rgba(229, 231, 235, 0.8)',
        background: 'linear-gradient(145deg, #ffffff 0%, #fafafa 100%)',
        overflow: 'hidden',
      }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          gap: '23px',
          padding: '20px',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '11px',
            alignItems: 'center',
            paddingTop: '7px',
          }}
        >
          <InfoIcon />
          <Box
            sx={{
              borderLeft: '2px solid #45009C',
              height: '24px',
            }}
          ></Box>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Typography sx={{ color: '#17052D' }} variant="h6">
            Average daily number of birds per wind speed range
          </Typography>
          <Typography
            sx={{
              color: '#8B8296',
              fontSize: '14px',
              paddingTop: '10px',
              maxWidth: '600px',
            }}
            variant="body2"
          >
            This graph shows the average daily number of birds distributed by
            wind speed in the selected date range
          </Typography>
        </Box>
      </Box>
      <WindSpeedGraph categories={categories} values={values} />
    </Paper>
  );
};
